import { FC } from 'react';
import { Control, FieldValues, UseFormSetError, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { PaymentMethod } from 'types';
import InHouse from './InHouse';
import BorderLess from './Borderless';
import Passim from './PassimPay';
import PayKassma from './PayKassma';
import AvadaPay from './AvadaPay';
import CaspianPay from './CaspianPay';

export const PAYMENT_AGGREGATORS = {
  IN_HOUSE: 3,
  BORDER_LESS: 4,
  PASSIM_PAY: 5,
  PAY_KASSMA: 6,
  AVADA_PAY: 9,
  CASPIAN_PAY: 10,
};

const PaymentService: FC<{
  isDeposit: boolean;
  onClose: () => void;
  getValues: () => FieldValues;
  paymentMethod: PaymentMethod;
  control: Control<FieldValues, unknown>;
  watch: UseFormWatch<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  setError: UseFormSetError<FieldValues>;
  changeAmountFieldVisibility: (isVisible: boolean) => void;
  changeActionButtonVisibility: (isVisible: boolean) => void;
  changeActionButtonAvailability: (isAvailable: boolean) => void;
}> = (props) => {
  const aggregatorId = props.paymentMethod?.method?.provider.aggregator.id;
  if (PAYMENT_AGGREGATORS.IN_HOUSE === aggregatorId) {
    return <InHouse {...props} />;
  }

  if (PAYMENT_AGGREGATORS.BORDER_LESS === aggregatorId) {
    return <BorderLess {...props} />;
  }

  if (PAYMENT_AGGREGATORS.PASSIM_PAY === aggregatorId) {
    return <Passim {...props} />;
  }

  if (PAYMENT_AGGREGATORS.PAY_KASSMA === aggregatorId) {
    return <PayKassma {...props} />;
  }

  if (PAYMENT_AGGREGATORS.AVADA_PAY === aggregatorId) {
    return <AvadaPay {...props} />;
  }

  if (PAYMENT_AGGREGATORS.CASPIAN_PAY === aggregatorId) {
    return <CaspianPay {...props} />;
  }

  console.log('payment service not found');
  return null;
};

export default PaymentService;
